(() => {
  const SELECTOR = '[data-collection-bundle-builder]';
  const MAX_VISIBLE_PRODUCTS = 10;
  const SLIDER_STYLE_ID = 'cbb-product-slider-runtime-styles';

  function getProductRecords(productCards) {
    return productCards.map((card, index) => ({
      card,
      index,
      available:
        card.dataset.productAvailable !== 'false' &&
        Boolean(card.dataset.variantId),
      filterKey: card.dataset.cbbFilterKey || 'all',
    }));
  }

  function getEligibleProducts(productRecords) {
    return productRecords.filter((product) => product.available);
  }

  function getMatchingProducts(eligibleProducts, activeFilter) {
    return eligibleProducts.filter((product) => product.filterKey === activeFilter);
  }

  function ensureSliderStyles() {
    if (document.getElementById(SLIDER_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SLIDER_STYLE_ID;
    style.textContent = `
      .cbb--all-collections .cbb__filter-slider {
        display: block !important;
        margin-bottom: 0 !important;
      }

      .cbb--all-collections .cbb__filter-slider .cbb__filters {
        margin-bottom: 20px !important;
        padding-bottom: 4px !important;
      }

      .cbb--all-collections .cbb__filter-arrow,
      .cbb--all-collections [data-cbb-filter-prev],
      .cbb--all-collections [data-cbb-filter-next] {
        display: none !important;
      }

      .cbb__product-slider {
        position: relative;
        min-width: 0;
      }

      .cbb--all-collections .cbb__product-slider .cbb__grid {
        display: grid;
        grid-template-columns: none !important;
        grid-auto-flow: column;
        grid-auto-columns: calc((100% - 56px) / 5);
        gap: 14px;
        overflow-x: auto;
        overflow-y: hidden;
        overscroll-behavior-x: contain;
        scroll-behavior: smooth;
        scroll-snap-type: x mandatory;
        scrollbar-width: none;
        padding: 2px 0 6px;
      }

      .cbb--all-collections .cbb__product-slider .cbb__grid::-webkit-scrollbar {
        display: none;
      }

      .cbb--all-collections .cbb__product-slider .cbb__product-card {
        width: 100%;
        scroll-snap-align: start;
      }

      .cbb__product-slider-arrow {
        position: absolute;
        z-index: 8;
        top: 50%;
        display: grid;
        width: 42px;
        height: 42px;
        place-items: center;
        padding: 0;
        border: 1px solid var(--cbb-border);
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.97);
        color: var(--cbb-heading);
        cursor: pointer;
        box-shadow: 0 8px 24px rgba(23, 23, 22, 0.12);
        transform: translateY(-50%);
        transition: border-color 180ms ease, color 180ms ease, opacity 180ms ease, box-shadow 180ms ease;
      }

      .cbb__product-slider-arrow--prev {
        left: -20px;
      }

      .cbb__product-slider-arrow--next {
        right: -20px;
      }

      .cbb__product-slider-arrow:hover:not(:disabled),
      .cbb__product-slider-arrow:focus-visible:not(:disabled) {
        border-color: var(--cbb-accent);
        color: var(--cbb-accent);
        box-shadow: 0 10px 28px rgba(23, 23, 22, 0.16);
      }

      .cbb__product-slider-arrow:focus-visible {
        outline: 3px solid rgba(214, 41, 104, 0.2);
        outline-offset: 2px;
      }

      .cbb__product-slider-arrow:disabled {
        cursor: default;
        opacity: 0.32;
      }

      .cbb__product-slider-arrow[hidden] {
        display: none !important;
      }

      .cbb__product-slider-arrow svg {
        display: block;
        width: 18px;
        height: 18px;
      }

      @media (min-width: 768px) and (max-width: 1023px) {
        .cbb--all-collections .cbb__product-slider .cbb__grid {
          grid-auto-columns: calc((100% - 48px) / 4);
          gap: 16px;
        }
      }

      @media (max-width: 767px) {
        .cbb--all-collections .cbb__product-slider .cbb__grid {
          grid-auto-columns: calc((100% - 14px) / 2);
          gap: 14px;
        }

        .cbb__product-slider-arrow {
          width: 36px;
          height: 36px;
        }

        .cbb__product-slider-arrow--prev {
          left: 4px;
        }

        .cbb__product-slider-arrow--next {
          right: 4px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function init(root) {
    if (!root || root.dataset.cbbInitialized === 'true') return;
    root.dataset.cbbInitialized = 'true';

    const productCards = Array.from(root.querySelectorAll('[data-cbb-product]'));
    productCards.forEach((card) => {
      card.dataset.cbbFilterKey = 'all';
    });

    const productRecords = getProductRecords(productCards);
    const productRecordByCard = new WeakMap(productRecords.map((product) => [product.card, product]));
    const eligibleProducts = getEligibleProducts(productRecords);
    const bundleButtons = Array.from(root.querySelectorAll('[data-cbb-bundle-size]'));
    const filterButtons = Array.from(root.querySelectorAll('[data-cbb-filter]'));
    const filterTrack = root.querySelector('[data-cbb-filter-track]');
    const filterPrev = root.querySelector('[data-cbb-filter-prev]');
    const filterNext = root.querySelector('[data-cbb-filter-next]');
    const grid = root.querySelector('.cbb__grid');
    let productTrack = root.querySelector('[data-cbb-product-track]') || grid;
    let productPrev = root.querySelector('[data-cbb-product-prev]');
    let productNext = root.querySelector('[data-cbb-product-next]');
    const baseCard = productCards[0] || null;
    const countEls = Array.from(root.querySelectorAll('[data-cbb-selected-count]'));
    const dynamicMessageEls = Array.from(root.querySelectorAll('[data-cbb-dynamic-message]'));
    const rewardHeadlineEls = Array.from(root.querySelectorAll('[data-cbb-reward-headline]'));
    const rewardTextEls = Array.from(root.querySelectorAll('[data-cbb-reward-text]'));
    const statusPills = Array.from(root.querySelectorAll('[data-cbb-status-pill]'));
    const progressBars = Array.from(root.querySelectorAll('[data-cbb-progress-bar]'));
    const productCount = root.querySelector('[data-cbb-product-count]');
    const emptyState = root.querySelector('[data-cbb-empty]');
    const clearFilter = root.querySelector('[data-cbb-clear-filter]');
    const showMoreWrap = root.querySelector('[data-cbb-show-more-wrap]');
    const addButton = root.querySelector('[data-cbb-add]');
    const addButtonLabel = root.querySelector('[data-cbb-add-label]');
    const cartStatus = root.querySelector('[data-cbb-cart-status]');
    const modal = root.querySelector('[data-cbb-modal]');
    const modalOpeners = Array.from(root.querySelectorAll('[data-cbb-modal-open]'));
    const modalClosers = modal ? Array.from(modal.querySelectorAll('[data-cbb-modal-close]')) : [];
    const iframe = modal ? modal.querySelector('iframe[data-cbb-video]') : null;
    const hostedVideo = modal ? modal.querySelector('video[data-cbb-video]') : null;

    const targetSix = Number(root.dataset.sixTarget || 6);
    const targetTen = Number(root.dataset.tenTarget || 10);
    const sixDiscount = Number(root.dataset.sixDiscount || 10);
    const tenDiscount = Number(root.dataset.tenDiscount || 15);
    const visibleProductLimit = MAX_VISIBLE_PRODUCTS;
    const productSliderMode =
      root.dataset.productSliderMode === 'true' ||
      root.classList.contains('cbb--all-collections');
    const cartSuccessMessage = root.dataset.cartSuccess || 'Bundle added to your basket.';
    const cartErrorMessage = root.dataset.cartError || 'Unable to add the bundle. Please try again.';
    const loadedFilters = new Set(['all']);
    const loadingFilters = new Map();

    let bundleSize = Number(root.dataset.defaultBundle || 6) === 10 ? 10 : 6;
    let activeFilter = 'all';
    let lastFocused = null;
    const selected = new Set();

    if (showMoreWrap) showMoreWrap.hidden = true;

    function ensureProductSliderControls() {
      if (!productSliderMode || !grid) return;

      ensureSliderStyles();

      let slider = grid.closest('.cbb__product-slider');
      if (!slider) {
        slider = document.createElement('div');
        slider.className = 'cbb__product-slider';
        grid.parentNode.insertBefore(slider, grid);
        slider.appendChild(grid);
      }

      productTrack = grid;
      productTrack.setAttribute('data-cbb-product-track', '');

      if (!productPrev) {
        productPrev = document.createElement('button');
        productPrev.type = 'button';
        productPrev.className = 'cbb__product-slider-arrow cbb__product-slider-arrow--prev';
        productPrev.setAttribute('data-cbb-product-prev', '');
        productPrev.setAttribute('aria-label', 'Previous products');
        productPrev.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m12.5 5-5 5 5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        slider.insertBefore(productPrev, productTrack);
      }

      if (!productNext) {
        productNext = document.createElement('button');
        productNext.type = 'button';
        productNext.className = 'cbb__product-slider-arrow cbb__product-slider-arrow--next';
        productNext.setAttribute('data-cbb-product-next', '');
        productNext.setAttribute('aria-label', 'Next products');
        productNext.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m7.5 5 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        slider.appendChild(productNext);
      }
    }

    ensureProductSliderControls();

    function selectedCount() {
      return selected.size;
    }

    function setText(elements, value) {
      elements.forEach((element) => {
        element.textContent = value;
      });
    }

    function syncFilterArrows() {
      if (!filterTrack || !filterPrev || !filterNext) return;

      const maxScroll = Math.max(0, filterTrack.scrollWidth - filterTrack.clientWidth);
      const hasOverflow = maxScroll > 2;

      filterPrev.hidden = !hasOverflow;
      filterNext.hidden = !hasOverflow;
      filterPrev.disabled = !hasOverflow || filterTrack.scrollLeft <= 2;
      filterNext.disabled = !hasOverflow || filterTrack.scrollLeft >= maxScroll - 2;
    }

    function scrollFilters(direction) {
      if (!filterTrack) return;

      const chips = Array.from(filterTrack.querySelectorAll('[data-cbb-filter]'));
      const firstVisibleChip = chips.find((chip) => {
        const chipLeft = chip.offsetLeft;
        return chipLeft + chip.offsetWidth > filterTrack.scrollLeft + 2;
      });
      const chipWidth = firstVisibleChip ? firstVisibleChip.offsetWidth : 120;
      const styles = window.getComputedStyle(filterTrack);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const step = Math.max(chipWidth + gap, filterTrack.clientWidth * 0.65);

      filterTrack.scrollBy({
        left: direction * step,
        behavior: 'smooth',
      });
    }

    function syncProductSliderArrows() {
      if (!productSliderMode || !productTrack) return;

      const maxScroll = Math.max(0, productTrack.scrollWidth - productTrack.clientWidth);
      const hasOverflow = maxScroll > 2;

      if (productPrev) {
        productPrev.hidden = !hasOverflow;
        productPrev.disabled = !hasOverflow || productTrack.scrollLeft <= 2;
      }

      if (productNext) {
        productNext.hidden = !hasOverflow;
        productNext.disabled = !hasOverflow || productTrack.scrollLeft >= maxScroll - 2;
      }
    }

    function scrollProducts(direction) {
      if (!productSliderMode || !productTrack) return;
      const visibleCard = Array.from(productTrack.querySelectorAll('[data-cbb-product]')).find((card) => !card.hidden);
      const cardWidth = visibleCard ? visibleCard.getBoundingClientRect().width : 0;
      const styles = window.getComputedStyle(productTrack);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const step = Math.max(cardWidth + gap, productTrack.clientWidth * 0.8);

      productTrack.scrollBy({
        left: direction * step,
        behavior: 'smooth',
      });
    }

    function bundleMessage(count) {
      if (count < targetSix) {
        const remaining = targetSix - count;
        return `Add ${remaining} more card${remaining === 1 ? '' : 's'} to unlock ${sixDiscount}% off.`;
      }
      if (count < targetTen) {
        const remaining = targetTen - count;
        return `${sixDiscount}% bundle discount unlocked. Add ${remaining} more card${remaining === 1 ? '' : 's'} to unlock ${tenDiscount}% off.`;
      }
      return `Maximum ${tenDiscount}% bundle saving unlocked.`;
    }

    function rewardHeadline(count) {
      if (count < targetSix) return `Unlock ${sixDiscount}% off with your 6-card bundle`;
      if (count < targetTen) return `Upgrade to ${tenDiscount}% off with the 10-pack`;
      return `${tenDiscount}% bundle saving unlocked`;
    }

    function rewardText(count) {
      if (count < targetTen) return bundleMessage(count);
      return `Maximum bundle saving unlocked — ${tenDiscount}% off.`;
    }

    function statusText(count) {
      if (count >= targetTen) return `${tenDiscount}% saving unlocked`;
      if (count < targetSix) {
        const remaining = targetSix - count;
        return `${remaining} left to unlock ${sixDiscount}% off`;
      }
      return `${targetTen - count} left to unlock ${tenDiscount}% off`;
    }

    function addLabel(count) {
      if (count === targetSix) return root.dataset.addSixLabel || 'Add 6 Pack Bundle to Basket';
      if (count === targetTen) return root.dataset.addTenLabel || 'Add 10 Pack Bundle to Basket';
      if (count < targetSix) return `Choose ${targetSix - count} More`;
      return `Choose ${targetTen - count} More for Max Saving`;
    }

    function syncBundleButtons() {
      bundleButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.cbbBundleSize) === bundleSize));
      });

      root.querySelectorAll('[data-cbb-mobile-bundle-title]').forEach((element) => {
        element.textContent = `Build a ${bundleSize} Pack`;
      });

      root.querySelectorAll('[data-cbb-mobile-kicker]').forEach((element) => {
        element.textContent = bundleSize === 10
          ? `Best value • ${tenDiscount}% off`
          : `${sixDiscount}% off`;
      });

      root.querySelectorAll('[data-cbb-mobile-benefit-cards]').forEach((element) => {
        element.textContent = `Choose ${bundleSize} cards`;
      });

      root.querySelectorAll('[data-cbb-mobile-benefit-extra]').forEach((element) => {
        element.textContent = bundleSize === 10
          ? `Save ${tenDiscount}%`
          : `Save ${sixDiscount}%`;
      });

      root.querySelectorAll('[data-cbb-mobile-benefit-shipping]').forEach((element) => {
        element.hidden = bundleSize !== 10;
      });
    }

    function formatPrice(value) {
      const amount = Number(value || 0);
      if (!Number.isFinite(amount)) return '';

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'GBP',
        }).format(amount);
      } catch (error) {
        return `£${amount.toFixed(2)}`;
      }
    }

    function createCollectionCard(product, variant, filterKey, index) {
      if (!baseCard || !grid || !product || !variant) return null;

      const card = baseCard.cloneNode(true);
      card.hidden = true;
      card.disabled = false;
      card.classList.remove('is-selected');
      card.dataset.cbbFilterKey = filterKey;
      card.dataset.productId = String(product.id || '');
      card.dataset.productHandle = product.handle || '';
      card.dataset.productAvailable = 'true';
      card.dataset.productPosition = String(index);
      card.dataset.variantId = String(variant.id || '');
      card.setAttribute('aria-pressed', 'false');
      card.setAttribute('aria-label', `Select ${product.title || 'product'}`);

      card.querySelector('.cbb__badge')?.remove();

      const media = card.querySelector('.cbb__media');
      const imageSource = product.images?.[0]?.src || product.image?.src || '';
      if (media) {
        media.replaceChildren();
        if (imageSource) {
          const image = document.createElement('img');
          image.className = 'cbb__image';
          image.src = imageSource;
          image.alt = product.images?.[0]?.alt || product.title || '';
          image.loading = 'lazy';
          image.decoding = 'async';
          media.appendChild(image);
        }
      }

      const title = card.querySelector('.cbb__product-title');
      if (title) title.textContent = product.title || '';

      const price = card.querySelector('.cbb__price');
      if (price) price.textContent = formatPrice(variant.price);

      card.addEventListener('click', () => toggleProduct(card));
      grid.appendChild(card);
      productCards.push(card);

      const record = {
        card,
        index: productRecords.length,
        available: true,
        filterKey,
      };

      productRecords.push(record);
      eligibleProducts.push(record);
      productRecordByCard.set(card, record);
      return card;
    }

    async function ensureCollectionProducts(filterKey) {
      if (filterKey === 'all' || loadedFilters.has(filterKey)) return;
      if (loadingFilters.has(filterKey)) return loadingFilters.get(filterKey);

      const prefix = 'collection::';
      if (!filterKey.startsWith(prefix)) return;

      const handle = filterKey.slice(prefix.length);
      if (!handle || !baseCard || !grid) return;

      const request = (async () => {
        try {
          const rootPath = window.Shopify?.routes?.root || '/';
          const requestLimit = productSliderMode ? 250 : 20;
          let page = 1;
          let added = 0;
          let keepLoading = true;

          while (keepLoading) {
            const response = await fetch(
              `${rootPath}collections/${encodeURIComponent(handle)}/products.json?limit=${requestLimit}&page=${page}`,
              {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
              }
            );

            if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
            const payload = await response.json();
            const products = Array.isArray(payload.products) ? payload.products : [];

            for (const product of products) {
              if (!productSliderMode && added >= MAX_VISIBLE_PRODUCTS) {
                keepLoading = false;
                break;
              }

              const variant = Array.isArray(product.variants)
                ? product.variants.find((item) => item.available !== false)
                : null;
              if (!variant) continue;

              if (createCollectionCard(product, variant, filterKey, added)) added += 1;
            }

            if (!productSliderMode || products.length < requestLimit) {
              keepLoading = false;
            } else {
              page += 1;
            }
          }

          loadedFilters.add(filterKey);
        } catch (error) {
          console.warn('Bundle Builder: unable to load collection products.', error);
        } finally {
          loadingFilters.delete(filterKey);
        }
      })();

      loadingFilters.set(filterKey, request);
      return request;
    }

    function updateExistingProducts() {
      const matchingProducts = getMatchingProducts(eligibleProducts, activeFilter);
      const visibleProducts = productSliderMode
        ? matchingProducts
        : matchingProducts.slice(0, visibleProductLimit);
      const visibleCards = new Set(visibleProducts.map((product) => product.card));

      productRecords.forEach((product) => {
        product.card.hidden = !visibleCards.has(product.card);
      });

      if (productCount) {
        productCount.textContent = productSliderMode
          ? `Showing all ${matchingProducts.length} cards`
          : `Showing ${visibleProducts.length} of ${matchingProducts.length} cards`;
      }
      if (emptyState) emptyState.hidden = matchingProducts.length !== 0;
      if (showMoreWrap) showMoreWrap.hidden = true;
      if (clearFilter) clearFilter.hidden = activeFilter === 'all';

      if (productSliderMode) {
        window.requestAnimationFrame(syncProductSliderArrows);
      }
    }

    function render() {
      const count = selectedCount();
      if (count >= targetSix) bundleSize = 10;

      syncBundleButtons();
      setText(countEls, `${count}/${bundleSize} selected`);
      setText(dynamicMessageEls, bundleMessage(count));
      setText(rewardHeadlineEls, rewardHeadline(count));
      setText(rewardTextEls, rewardText(count));
      setText(statusPills, statusText(count));

      progressBars.forEach((bar) => {
        bar.style.width = `${Math.min((count / targetTen) * 100, 100)}%`;
      });

      productRecords.forEach((product) => {
        const id = product.card.dataset.variantId;
        const isSelected = selected.has(id);
        product.card.classList.toggle('is-selected', isSelected);
        product.card.setAttribute('aria-pressed', String(isSelected));
        product.card.disabled = !product.available || (!isSelected && count >= targetTen);
      });

      const ready = count === targetSix || count === targetTen;
      if (addButton) addButton.disabled = !ready;
      if (addButtonLabel) addButtonLabel.textContent = addLabel(count);
      updateExistingProducts();
    }

    function toggleProduct(card) {
      const record = productRecordByCard.get(card);
      if (!record?.available) return;

      const id = card.dataset.variantId;
      if (!id) return;

      if (selected.has(id)) selected.delete(id);
      else if (selected.size < targetTen) selected.add(id);
      render();
    }

    async function setFilter(filter) {
      activeFilter = filter || 'all';
      filterButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.cbbFilter === activeFilter));
      });

      if (activeFilter !== 'all' && productCount) productCount.textContent = 'Loading cards…';
      await ensureCollectionProducts(activeFilter);
      render();

      if (productSliderMode && productTrack) {
        productTrack.scrollTo({ left: 0, behavior: 'smooth' });
        window.requestAnimationFrame(syncProductSliderArrows);
      }
    }

    function normalizeVideoUrl(url) {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.hostname.includes('youtu.be')) {
          const id = parsed.pathname.replace(/^\//, '').split('/')[0];
          return id ? `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1` : url;
        }
        if (parsed.hostname.includes('youtube.com')) {
          const id = parsed.searchParams.get('v') || parsed.pathname.split('/').filter(Boolean).pop();
          return id ? `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1` : url;
        }
        if (parsed.hostname.includes('vimeo.com')) {
          const id = parsed.pathname.split('/').filter(Boolean).pop();
          return id ? `https://player.vimeo.com/video/${id}?autoplay=1` : url;
        }
      } catch (error) {
        return url;
      }
      return url;
    }

    function openModal(trigger) {
      if (!modal) return;
      lastFocused = trigger || document.activeElement;
      modal.hidden = false;
      document.body.classList.add('cbb-modal-open');
      if (iframe) iframe.src = normalizeVideoUrl(iframe.dataset.src || '');
      if (hostedVideo) {
        hostedVideo.currentTime = 0;
        hostedVideo.play().catch(() => {});
      }
      const closeButton = modal.querySelector('[data-cbb-modal-close]');
      if (closeButton) closeButton.focus();
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('cbb-modal-open');
      if (iframe) iframe.src = '';
      if (hostedVideo) hostedVideo.pause();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    async function addToCart() {
      const count = selectedCount();
      if (count !== targetSix && count !== targetTen) return;

      const items = Array.from(selected).map((variantId) => ({
        id: Number(variantId),
        quantity: 1,
        properties: {
          '_Bundle': `${count}-card bundle`,
          '_Bundle section': root.dataset.sectionId || '',
        },
      }));

      if (!items.length || items.some((item) => !item.id)) return;
      addButton.classList.add('is-loading');
      addButton.disabled = true;

      if (cartStatus) {
        cartStatus.textContent = root.dataset.addingLabel || 'Adding bundle…';
        cartStatus.classList.remove('is-error');
      }

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result?.description || 'Cart request failed');

        if (cartStatus) cartStatus.textContent = cartSuccessMessage;

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        const cartTrigger = document.querySelector('#cart-icon-bubble');
        if (cartTrigger) {
          window.requestAnimationFrame(() => cartTrigger.click());
        }
      } catch (error) {
        if (cartStatus) {
          cartStatus.textContent = cartErrorMessage;
          cartStatus.classList.add('is-error');
        }
      } finally {
        addButton.classList.remove('is-loading');
        render();
      }
    }

    productCards.forEach((card) => card.addEventListener('click', () => toggleProduct(card)));

    bundleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const requested = Number(button.dataset.cbbBundleSize) === 10 ? 10 : 6;
        bundleSize = selected.size >= targetSix ? 10 : requested;
        render();
      });
    });

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => setFilter(button.dataset.cbbFilter));
    });

    if (filterPrev) filterPrev.addEventListener('click', () => scrollFilters(-1));
    if (filterNext) filterNext.addEventListener('click', () => scrollFilters(1));
    if (filterTrack) {
      filterTrack.addEventListener('scroll', syncFilterArrows, { passive: true });
      window.addEventListener('resize', syncFilterArrows);
      window.requestAnimationFrame(syncFilterArrows);
    }

    if (clearFilter) clearFilter.addEventListener('click', () => setFilter('all'));
    if (productPrev) productPrev.addEventListener('click', () => scrollProducts(-1));
    if (productNext) productNext.addEventListener('click', () => scrollProducts(1));
    if (productSliderMode && productTrack) {
      productTrack.addEventListener('scroll', syncProductSliderArrows, { passive: true });
      window.addEventListener('resize', syncProductSliderArrows);
    }
    if (addButton) addButton.addEventListener('click', addToCart);
    modalOpeners.forEach((button) => button.addEventListener('click', () => openModal(button)));
    modalClosers.forEach((button) => button.addEventListener('click', closeModal));

    if (modal) {
      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeModal();
        if (event.key !== 'Tab') return;

        const focusable = Array.from(
          modal.querySelectorAll('button, [href], iframe, video, [tabindex]:not([tabindex="-1"])')
        ).filter((element) => !element.hidden && !element.disabled);

        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    render();
  }

  function initWithin(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches(SELECTOR)) init(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initWithin(document));
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();